import { dotsState, dotLabel } from './ggPlayDots.js'

// Dots add-on results (frame plug-in). Settles from auto birdies/eagles + tapped
// dots, zero-sum pairwise, as a SEPARATE line alongside Wolf / Skins / Scats.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
const money = (v) => (v >= 0 ? `+$${Math.round(v)}` : `−$${Math.round(-v)}`)

export default function GDotsResults({ game }) {
  const st = dotsState(game)
  if (!st) return null
  return (
    <div className="mt-4">
      <div className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-1">💠 Dots — side game</div>
      <p className="text-sm text-gray-500 mb-2">${st.dotValue}/dot · {st.dotsInPlay.map((k) => dotLabel(k).label).join(', ')} · {st.total} dot{st.total === 1 ? '' : 's'} · zero-sum pairwise.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Player', 'Dots', 'Net'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{st.rows.map((r) => (
          <tr key={r.id}>
            <td style={cell}>{r.name}</td>
            <td style={cell}>{r.dots}{Object.keys(r.breakdown).length ? <span className="text-xs text-gray-400 ml-1">({Object.entries(r.breakdown).map(([k, v]) => `${dotLabel(k).label}${v > 1 ? '×' + v : ''}`).join(', ')})</span> : null}</td>
            <td style={cell}><b style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#374151' }}>{money(r.net)}</b></td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
